import { render, staticRenderFns } from "./StackedColumns3d.vue?vue&type=template&id=47f359da&"
import script from "./StackedColumns3d.vue?vue&type=script&lang=js&"
export * from "./StackedColumns3d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports